import { BackIcon, LogoIcon } from "assets/icons";
import Notification from "components/Header/Notification/Notification";
import { PageButton } from "components/Header/styles";
import SigninModal from "components/Signup/Modal/SigninModal";
import useModal from "hooks/useModal";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { getIsUser } from "utils/utility";
import HeaderLayout from "../HeaderLayout/HeaderLayout";

const HEADER_MENU: Record<
  string,
  { left?: string; center?: string; right?: string }
> = {
  "/mypage": {
    left: "마이페이지",
    right: "alarm",
  },
  "/mypage/edit": {
    left: "back",
  },
  "/mypage/expert": {
    left: "back",
    center: "정보수정",
  },
  "/mypage/ibs": {
    left: "back",
    center: "IBS",
  },
  "/mypage/membership": {
    left: "back",
    center: "멤버십/열람권 관리",
  },
  "/mypage/activity": {
    left: "back",
    center: "나의 활동",
  },
  // "/mypage/matching": {
  //   left: "back",
  //   center: "매칭 관리",
  // },
  "/mypage/service-center": {
    left: "back",
    center: "고객센터",
  },
  "/mypage/term": {
    left: "back",
    center: "Charting 이용약관",
  },
  "/diagnosis": {
    left: "back",
    center: "IBS 자가진단표",
  },
  "/diagnosis/result/id": {
    center: "IBS 자가진단 결과",
  },
  "/matching": {
    left: "전문가찾기",
    right: "alarm",
  },
  "/matching/detail/id": {
    left: "back",
  },
  "/news": {
    left: "back",
    center: "뉴스",
  },
  "/community": {
    left: "back",
    center: "나의 활동",
  },
  "/community/list": {
    left: "back",
    center: "나의 활동",
  },
  "/community/write": {
    left: "back",
    center: "글쓰기",
  },
  "/community/detail/id": {
    left: "back",
  },
  "/data-room": {
    left: "logo",
    right: "alarm",
  },
  "/membership": {
    left: "logo",
    right: "alarm",
  },
};

function MobileHeader() {
  const { pathname } = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const {
    isOpen: isOpenSigninModal,
    openModal: openSigninModal,
    closeModal: closeSigninModal,
  } = useModal();

  const isUser = getIsUser();

  const basePath = Object.keys(params).length
    ? pathname.split("/").slice(0, -1).join("/") + "/id"
    : pathname;

  const { left, center, right } = HEADER_MENU[basePath] || {};

  const renderLeft = (type: string) => {
    switch (type) {
      case "logo":
        return (
          <LogoIcon
            onClick={() => navigate("/data-room")}
            style={{ cursor: "pointer" }}
          />
        );
      case "back":
        return (
          <BackIcon
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          />
        );
      default:
        return <MainTitle>{type}</MainTitle>;
    }
  };

  return (
    <HeaderLayout>
      <Container>
        {left ? renderLeft(left) : <EmptyBox />}
        {center ? <CenterTitle>{center}</CenterTitle> : <EmptyBox />}
        {right && right === "alarm" ? (
          isUser ? (
            <Notification />
          ) : (
            <PageButton onClick={openSigninModal}>로그인/회원가입</PageButton>
          )
        ) : (
          <EmptyBox />
        )}
      </Container>
      {isOpenSigninModal && <SigninModal modalClose={closeSigninModal} />}
    </HeaderLayout>
  );
}

export default MobileHeader;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 5.8rem;
  padding: 1.7rem 1.6rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray[100]};
  background: ${(props) => props.theme.colors.white};

  position: fixed;
  top: 0;
  z-index: 1000;
`;

const EmptyBox = styled.div`
  width: 2.4rem;
  height: 2.4rem;
`;

export const CenterTitle = styled.div`
  ${(props) => props.theme.fonts.bd15};
`;

const MainTitle = styled.div`
  ${(props) => props.theme.fonts.bd18};
`;
